<template>
  <div class="login_prompt_container">
    
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          
          <card-generic
          title="Enter your email to begin"
          >

            <form
            id="form_login"
            >
              <div class="row">
                <div class="col-8 col-lg-10">
                  <input type="email" class="form-control"
                  placeholder="email address"
                  v-model="form.email"
                  >
                </div>
                <div class="col-4 col-lg-2">
                  <button type="submit" class="btn btn-secondary btn_login"
                  @click="check_form"
                  >

                    Go!

                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  
                  <b-form-checkbox
                  id="email_consent"
                  v-model="form.email_consent"
                  value="1"
                  unchecked-value="0"
                  >
                    I want to learn about contest events, nomination, and voting periods by receiving a one-time email with more info.
                  </b-form-checkbox>

                  <p class="small-text">
                    Your email address is required to start nominating and voting. We will not share or sell your email address with any 3rd parties.
                  </p>

                </div>
              </div>
            </form>
            
            <!-- LOGIN ERRORS DISPLAY -->
            <transition
            name="vote_cards" 
            mode="out-in"
            enter-active-class="animated flipInX" 
            leave-active-class="animated flipOutX"
            >

              <div class="login_form_errors alert alert-danger"
              v-if="errors.length > 0"
              >
                <ul>
                  <li
                  v-for="error in errors"
                  >
                    {{error}}
                  </li>
                </ul>
              </div>

            </transition>

          </card-generic>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CardGeneric from '@/components/cards/card_generic.vue'

export default {
  name: 'login_prompt',
  props: [
    
  ],
  data () {
    return {
      errors: [],
      form: {
        email: '',
        email_consent: '1'
      }
    }
  },
  methods: {
    check_form: function(e) {
      e.preventDefault();
      let vm = this;
      // console.log('checking: ');
      // RESET ERRORS
      vm.errors = [];

      // CHECK IF VALID EMAIL
      if(!vm.form.email) {
        vm.errors.push('Email required.');
      }
      else if(!vm.valid_email(vm.form.email)) {
        vm.errors.push('Valid email required.')
      }
      
      if(vm.errors.length < 1) {
        vm.log_in();
      }

    },
    log_in: function() {
      let vm = this;

      // INIT DATA
      let data = {
        email: vm.form.email,
        consent: vm.form.email_consent
      }

      this.$root.store.session.log_in(vm.form.email, vm.form.email_consent)
        .then(function() {
          
          // FIRE GA EVENT
          vm.$ga.event({
            eventCategory: 'Logins',
            eventAction: 'User Login',
            eventLabel: data.email
          })
        })
    },
    valid_email: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  components: {
    CardGeneric
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.login_prompt_container {

  .btn_login {
    background: $dcom-teal;
    border-color: $dcom-teal;
  }

  .login_form_errors {
    margin-top: 1em;
    
    ul {
      margin: 0;
    }
  }

  input {
    margin-bottom: 1em;
  }

  label {
    font-size: 0.9em;
    margin-bottom: 1em;
  }

  .small-text {
    font-size: 0.8em;
    font-style: italic;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/login/login_prompt.vue